var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheckSvgrepoCom11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.08594C10.0399 2.08594 10.5697 2.26084 11.8418 2.69629L12.2949 2.85156C13.4912 3.26105 14.3682 3.5612 14.9844 3.81152C15.2915 3.93631 15.5176 4.04224 15.6787 4.13574C15.8471 4.23352 15.9042 4.29518 15.917 4.31348C15.9313 4.33397 15.9705 4.41101 16.0078 4.60449C16.0435 4.78996 16.0707 5.04111 16.0889 5.375C16.1253 6.04411 16.125 6.97701 16.125 8.24902V9.49609C16.1249 13.6504 13.0155 15.6906 10.9639 16.5869H10.9629C10.6704 16.7147 10.4935 16.7912 10.2959 16.8418C10.1055 16.8905 9.87676 16.9189 9.5 16.9189C9.12324 16.9189 8.89454 16.8905 8.7041 16.8418C8.50644 16.7912 8.32879 16.7147 8.03613 16.5869L7.64062 16.4053C5.60844 15.4275 2.87514 13.3911 2.875 9.49609V8.24902L2.87988 6.58594C2.88448 6.11018 2.89292 5.70953 2.91113 5.375C2.92932 5.04111 2.95646 4.78996 2.99219 4.60449C3.02947 4.411 3.06867 4.33396 3.08301 4.31348C3.09585 4.29518 3.15293 4.23352 3.32129 4.13574C3.48246 4.04218 3.70921 3.9364 4.0166 3.81152C4.63276 3.56123 5.509 3.26099 6.70508 2.85156L7.1582 2.69629C8.43036 2.26083 8.9601 2.08594 9.5 2.08594Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckSvgrepoCom11);
export default __webpack_public_path__ + "static/media/shield-check-svgrepo-com 1 (1).91db4e2521956c5ae1b332e75d7cdeab.svg";
export { ForwardRef as ReactComponent };